import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/ZeroData/ZeroDataUsage.mdx";

import Examples from "../../Docs/Components/ZeroData/ZeroDataExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Zero data"
            description="Use zero data to communicate that there's no relevant data or results to display."
            apiSources={["azure-devops-ui/Components/ZeroData/ZeroData.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"github":"https://github.com/Microsoft/codex-design-system/issues/37"}}
            status={{"design":"Revision soon","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;